import React, { useEffect, useMemo, useState } from 'react'
import { get } from 'lodash'
import BreadCrumb from '../../../../components/BreadCrumb';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import Table from '../../../../components/CustomTable';
import { planTypeOptions } from './constant'
import routes from '../../../../routes';
import { Link, withRouter } from 'react-router-dom';
import Select from "react-select";
import { useFetchTenantsListData } from "../../../../hooks/useFetchTenantsListData";
import { useFetchCountryListData } from "../../../../hooks/useFetchCountryListData";
import { useDispatch, useSelector } from 'react-redux';
import { configAttributeAction, getAllCountryAction, getAllCurrencyAction, getSularCountryListAction, postListAllSubscriptionPlanMgrAction } from '../../../../actions';
import { PERMISSION } from '../../../../constants/permission';
import { checkPermission, checkTablePermission } from '../../../../utils/route-auth';
import moment from 'moment';
import { getDateFromUtcToSpecificZone, getTenantTimeZone } from '../../../../selectors';

const Card = asyncRoute(() => import('../../../../components/Card'));
const Tabs = asyncRoute(() => import('../../../../components/Tabs'));

function ListSubscriptionPlanMgr(props) {
    const [feeSettingsListAllData, setFeeSettingsListAllData] = useState([])
    const [popoverVisible, setPopoverVisible] = useState(false)
    const [planTypeFilter, setPlanTypeFilter] = useState({})
    const [currencyFilter, setCurrencyFilter] = useState({})
    const [countryFilter, setCountryFilter] = useState({})
    const [countryListOptions, setCountryListOptions] = useState([])
    const [currencyListOptions, setCurrencyListOptions] = useState([])
    const [durationOptionsList, setDurationUptionsList] = useState([])
    const tenantsData = useFetchTenantsListData();

    const targetTimeZone = getTenantTimeZone(tenantId);

    const options = useMemo(() => {
        return (
            checkTablePermission({ edit: PERMISSION.ADMIN.SUBSCRIPTIONPLANMANAGER.EDIT }, {
                columns: [
                    { id: 1, name: '', label: '', sortable: false, },
                    { id: 1, name: 'id', label: 'PLAN ID', sortable: false, },
                    { id: 2, name: 'name', label: 'PLAN NAME', sortable: true, type: 'string', },
                    { id: 2, name: 'displayName', label: 'DISPLAY NAME', sortable: true, type: 'string' },
                    { id: 3, name: 'planType', label: 'PLAN TYPE', sortable: false, type: 'string', component: (row) => <div>{row.planType == "1" ? "Standard" : row.planType == "2" ? "Custom" : '-'}</div> },
                    {
                        id: 4, name: 'currencySupported', label: 'CURRENCY SUPPORTED', sortable: false, type: 'number', component: (row) => (
                            <div>
                                {
                                    row.currencySupported == 0 ?
                                        'All' :
                                        (Array.isArray(currencyListOptions) && currencyListOptions.length > 0 ? currencyListOptions.find(item => item.value == row.currencySupported).label : '')
                                }
                            </div>
                        )
                    },
                    {
                        id: 5, name: 'countrySupported', label: 'COUNTRY SUPPORTED', sortable: false, type: 'number', component: (row) => (
                            <div>
                                {
                                    row.countrySupported == 0 ?
                                        'All' :
                                        (Array.isArray(countryListOptions) && countryListOptions.length > 0 ? countryListOptions.find(item => item.value == row.countrySupported) ? countryListOptions.find(item => item.value == row.countrySupported).label : "-" : '-')
                                }
                            </div>
                        )

                    },
                    {
                        id: 6, name: 'tenantSupported', label: 'TENANT SUPPORTED', sortable: false, type: 'string', component: (row) => (
                            <div>
                                {
                                    row.tenantSupported === 0 ?
                                        'All' :
                                        (Array.isArray(tenantsData) && tenantsData.length > 0 ? tenantsData.find(item => item.tenantId === row.tenantSupported).tenantName : '')
                                }
                            </div>
                        )
                    },
                    { id: 7, name: 'cost', label: 'AMOUNT', sortable: true, type: 'number', component: (row) => <div>{row.cost ? row.cost.toFixed(2) : '-'}</div> },
                    { id: 8, name: 'offerType', label: 'OFFER', sortable: false, type: 'number', component: (row) => <div>{row.offerType == "0" ? "NA" : row.offerType == "1" ? "IN %" : 'Fix'}</div> },
                    { id: 9, name: 'outage', label: 'OUTAGE %', sortable: true, type: 'number', component: (row) => <div>{row.outage ? row.outage.toFixed(2) : '-'}</div> },
                    { id: 10, name: 'spendLimit', label: 'SPEND LIMIT', sortable: true, type: 'number', component: (row) => <div>{row.spendLimit ? row.spendLimit : "NA"}</div> },
                    { id: 11, name: 'customDuration', label: 'DURATION (in days)', sortable: true, type: 'number', component: (row) => <div>{row.planType == "2" ? row.customDuration : durationOptionsList && durationOptionsList.length > 0 && durationOptionsList.find((item) => item.id == row.duration) ? durationOptionsList.find((item) => item.id == row.duration).value : '-'}</div> },
                    { id: 12, name: 'startDate', label: 'START DATE', sortable: false, type: 'number', component:(row) => row.startDate ? moment(getDateFromUtcToSpecificZone({date:row.startDate,targetTimeZone:targetTimeZone})).format("YYYY-MM-DD") : "-"},
                    { id: 13, name: 'endDate', label: 'END DATE', sortable: false, type: 'number', component:(row) =>row.endDate ? moment(getDateFromUtcToSpecificZone({date:row.endDate,targetTimeZone:targetTimeZone})).format("YYYY-MM-DD") : "-"},
                    { id: 14, name: 'displaySupported', label: 'DISPLAY SUPPORTED', sortable: false, type: 'number', component: (row) => <div>{row.displaySupported == "1" ? "YES" : row.displaySupported == "0" ? "NO" : '-'}</div> },
                    { id: 15, name: 'status', label: 'STATUS', sortable: true, type: 'number', component: (row) => <div>{row.status == "1" ? "Active" : row.status == "2" ? "Draft" : 'Inactive'}</div> },
                ],
                keyCol: 'ioNo',
                actionName: 'ACTIONS',
                actions: [
                    {
                        type: 'edit',
                        text: '',
                        icon: 'ti ti-pencil color-beki',
                        tooltip: 'Edit',
                        iconType: 'new'
                    },
                ],
                recActive: false,
                actionsThead: true,
                sortable: true,
                dateType: true,
                defaultSortParams: {
                    sortBy: 'txnDateTime',
                    sortOrder: 'desc'
                },
                showSearch: true,
                searchable: true,
                searchColumns: [
                    { key: 'displayName' },
                ],
                paging: true,
                defaultPagingParams: {
                    pageSize: 25
                }
            })
        )
    }, [countryListOptions, currencyListOptions, tenantsData, targetTimeZone]);

    const tenantId = useSelector((state) => get(state, 'app.preSignInState.tenantId', ''));
    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const dispatch = useDispatch();

    useEffect(() => {
        daysDuration();
        getListALLData();
        getCountryList();
        getCurrencyList();
        setPlanTypeFilter({ label: "All", value: null });
    }, [])

    const togglePopover = () => {
        setPopoverVisible(!popoverVisible);
    }

    const handleChange = (selected, name) => {
        if (name == "planType") {
            setPlanTypeFilter(selected);
        }
        if (name == "currencySupported") {
            setCurrencyFilter(selected);
        }
        if (name == "countrySuported") {
            setCountryFilter(selected);
        }
    }

    const getCountryList = async () => {

        await dispatch(getSularCountryListAction({ tenantId, authToken, userId }))
            .then((data) => {
                const {
                    responeCode: { status = "" },
                    responseList,
                } = data;

                if (status === "Success" && responseList && responseList.length > 0) {

                    const setCountryListData = responseList.map((data) => {
                        return {
                            value: data.id, label: data.countryName
                        }
                    })
                    // setCountryListData.unshift({ id: '0', value: 'All' })
                    setCountryListOptions(setCountryListData)

                } else {
                    console.log("list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });

    }

    const getCurrencyList = async () => {

        await dispatch(getAllCurrencyAction({ tenantId, authToken, userId }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    responseList,
                } = data;
                if (status === "Success" && responseList && responseList.length > 0) {
                    const setCurrencyListData = responseList.map((data) => {
                        return {
                            value: data.key, label: data.value
                        }
                    })
                    setCurrencyListOptions(setCurrencyListData)

                } else {
                    console.log("list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });

    }

    const getListALLData = async () => {
        const payload = {
            planType: null,
            countrySupported: null,
            currencySupported: null
        }

        await dispatch(postListAllSubscriptionPlanMgrAction({ tenantId, authToken, userId, payload }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success" && response && response.length > 0) {
                    setFeeSettingsListAllData(response)

                } else {
                    console.log("list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const ApplyBtn = async () => {
        const payload = {
            planType: planTypeFilter.label == "All" ? null : +planTypeFilter.value,
            countrySupported: Object.keys(countryFilter).length > 0 ? +countryFilter.value : null,
            currencySupported: Object.keys(currencyFilter).length > 0 ? +currencyFilter.value : null
        }

        await dispatch(postListAllSubscriptionPlanMgrAction({ tenantId, authToken, userId, payload }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success") {
                    setFeeSettingsListAllData(response)
                    setPopoverVisible(!popoverVisible)

                } else {
                    console.log("list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const handleReset = () => {
        setPlanTypeFilter({ label: "All", value: null });
        setCurrencyFilter({});
        setCountryFilter({})
        getListALLData();
        // setPopoverVisible(!popoverVisible)

    }

    const handelAction = (row, action) => {
        const { match, history } = props;
        if (action.type == "edit") {
            history.push(`${match.path}/${routes.admin.subscriptionPlanMgr.edit}/${row.id}`)
        }
    }

    const daysDuration = async () => {
        // let params = "PLAN_DURATION"

        await dispatch(configAttributeAction({ tenantId, authToken, userId, type: 'PLAN_DURATION' }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    responseList,
                } = data;
                if (status === "Success" && responseList && responseList.length > 0) {
                    const listData = responseList.map((ele) => {
                        return {
                            id: ele.key, value: ele.value
                        }
                    })
                    setDurationUptionsList(listData)
                } else {
                    console.log("Platform list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });


    }


    const { match } = props
    return (
        <>
            <div className="main-panel ion form__style">
                <div className="content-wrapper">
                    <BreadCrumb />
                    <div className="row mt-3">
                        <Tabs container="admin" />
                        <Card>

                            <div className='d-flex align-items-center justify-content-between mb-2'>
                                <div className='d-flex align-items-center  position-relative'>
                                    <button style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }} className='btn' onClick={togglePopover}>
                                        <i className='ti ti-filter ti-sm'></i>
                                        Filters
                                    </button>

                                    {popoverVisible && (
                                        <div className='popover'>

                                            <div style={{ background: "#F7F8FC" }} className='d-flex justify-content-between align-items-center p-3'>
                                                <h5 style={{ fontWeight: 500, margin: 0 }}>Filters</h5>
                                                <button className='close close-popover' onClick={togglePopover}>
                                                    &times;
                                                </button>
                                            </div>

                                            <div className='row flex-column p-3'>

                                                <div className='col-md-12 mb-2'>
                                                    <label>Plan Type :</label>
                                                    <Select
                                                        options={planTypeOptions}
                                                        isMulti={false}
                                                        defaultValue={planTypeFilter}
                                                        value={planTypeFilter}
                                                        onChange={(selected) => handleChange(selected, "planType")}
                                                        placeholder="--Select--"
                                                    />
                                                </div>
                                                <div className='col-md-12 mb-2'>
                                                    <label>Currency Supported :</label>
                                                    <Select
                                                        options={currencyListOptions}
                                                        isMulti={false}
                                                        defaultValue={currencyFilter}
                                                        value={currencyFilter}
                                                        onChange={(selected) => handleChange(selected, "currencySupported")}
                                                        placeholder="--Select--"
                                                    />
                                                </div>
                                                <div className='col-md-12 mb-2'>
                                                    <label>Country Supported :</label>
                                                    <Select
                                                        options={countryListOptions}
                                                        isMulti={false}
                                                        defaultValue={countryFilter}
                                                        value={countryFilter}
                                                        onChange={(selected) => handleChange(selected, "countrySuported")}
                                                        placeholder="--Select--"
                                                    />
                                                </div>




                                                {/* Apply And Cancel button */}
                                                <div className="col-md-12 mt-4 justify-content-end d-flex">
                                                    <button
                                                        onClick={() => handleReset()}
                                                        className="btn btn-outline-primary">Reset</button>
                                                    <button type="submit"
                                                        onClick={(e) => { ApplyBtn(e) }}
                                                        className="btn btn-primary bg-color-beki ml-3">Apply</button>
                                                </div>

                                            </div>
                                        </div>)}
                                </div>
                            </div>

                            {
                                checkPermission({
                                    permissions: [PERMISSION.ADMIN.SUBSCRIPTIONPLANMANAGER.ADD]
                                }) &&
                                <div className="margin-list-adj">
                                    <Link to={`${match.path}/${routes.admin.subscriptionPlanMgr.add}`}> <button className="btn btn-primary"><i className="mdi mdi-plus"></i>New Plan</button></Link>
                                </div>
                            }

                            <div className=" mt-5 campaign-list-adj table-responsive SubcriptionTable">
                                <Table
                                    options={options}
                                    data={feeSettingsListAllData.reverse() || []}
                                    handelAction={handelAction}
                                />
                            </div>

                        </Card>
                    </div>
                </div>
            </div>

        </>
    )
}

export default withRouter(ListSubscriptionPlanMgr)
